import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getHoveredChannel } from '../../../api/channels';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';
import { normalizeChannelHovercard } from '../../../components/Channels/utils/normalizeChannelHovercardList';

export const fetchHoveredChannel = createAsyncThunk(
  'channels/fetchHoveredChannel',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getHoveredChannel(
        { path, params },
        {
          cancelToken: source.token,
        },
      );
      return normalizeChannelHovercard(response.data);
    } catch (error) {
      return rejectWithValue(error?.response?.status);
    }
  },
);

export const fetchHoveredChannelExtraReducers = builder => {
  builder
    .addCase(fetchHoveredChannel.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.channels.hoveredChannels.request,
        action,
        generateChannelCIDKey(action.meta.arg.path),
      );
    })
    .addCase(fetchHoveredChannel.fulfilled, (state, action) => {
      const channelCIDKey = generateChannelCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.channels.hoveredChannels.request[channelCIDKey],
        action,
        () => {
          state.channels.hoveredChannels.byId[channelCIDKey] = action.payload;

          if (!state.channels.hoveredChannels.allIds.includes(channelCIDKey)) {
            state.channels.hoveredChannels.allIds.push(channelCIDKey);
          }
        },
      );
    })
    .addCase(fetchHoveredChannel.rejected, (state, action) => {
      handleRequestRejection(
        state.channels.hoveredChannels.request[
          generateChannelCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
